import React from 'react';

export interface WorkflowDiagramNodeProps {
    name: string;
    hasNext: boolean;
    status: 'pending' | 'active' | 'complete' | 'not-used';
}

export const WorkflowDiagramNode: React.FunctionComponent<WorkflowDiagramNodeProps> = ({
                                                                                           name,
                                                                                           hasNext,
                                                                                           status,
                                                                                       }) => {
    return (
        <>
            <div className={`workflow-node ${status}`}>
                {status === 'complete' && <i className="far fa-check-circle" />}
                {status === 'not-used' && <i className="fas fa-ban" />}
                <h5 className="title">{name}</h5>
            </div>
            {hasNext && <i className="next-step-arrow fas fa-arrow-right" />}
        </>
    );
}